"use server";

import { PageContextProviderProps, PageContextSchema } from "./schema";

let CONTEXT_STORE: any;

type ServerContext<T> = {
    Provider: ({
        children,
        value,
    }: {
        children: React.ReactNode;
        value?: T;
    }) => React.ReactNode;
    Consumer: ({
        children,
    }: {
        children: (context: T | undefined) => React.ReactNode;
    }) => React.ReactNode;
    _defaultValue: T | undefined;
};

export function createServerContext<T>(defaultValue: T): ServerContext<T> {
    return {
        Provider: ({ children, value }) => {
            CONTEXT_STORE = value;
            return children;
        },
        Consumer: ({ children }) => {
            return children(CONTEXT_STORE);
        },
        _defaultValue: defaultValue,
    };
}

const ServerContext = createServerContext<PageContextSchema | null>(null);

export function getServerContext<T>({ _defaultValue }: ServerContext<T>) {
    return _defaultValue;
}

const ServerContextProvider: React.FC<PageContextProviderProps> = ({
    data,
    children,
}) => <ServerContext.Provider value={data}>{children}</ServerContext.Provider>;

export const usePageServerContext = () => {
    return getServerContext(ServerContext);
};

export default ServerContextProvider;
